export { Typography, type IProps, TYPOGRAPHY_VARIANT } from "./Typography";
